import { CLASS_NAMES, EVENTS } from '@bs/constants';
import { MessageBus } from '@bs/utils';

/**
 * A class for the Card module
 */
export default class ResearchSidebarFilters extends MessageBus {
  /**
   * Constructor function of the ResearchSidebarFilters class. Must receive one arguments, a DOM
   * node representing a delivery ticket.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    /**
     * DOM node that is passed into the constructor
     * @property {object} element DOM node that is passed into the constructor
     */
    this.element = element;

    // Initialize the view
    this.init();
  }

  /**
   * Initializes the view by calling the functions to
   * create DOM references, setup event handlers and
   * then create the event listeners
   * @returns {object} ResearchSidebarFilters A reference to the current instance of the class
   * @chainable
   */
  init() {
    this.cacheDomReferences().setupHandlers().enable();

    return this;
  }

  /**
   * Cache DOM References
   *
   * Find all necessary DOM elements used in the view and cache them
   * @returns {object} ResearchSidebarFilters A reference to the current instance of the class
   * @chainable
   */
  cacheDomReferences() {
    this.selectFilters = this.element.querySelector(
      `.${CLASS_NAMES.RESEARCH_SELECT_FILTERS}`
    );
    this.filtersWrapper = this.element.querySelector(
      `.${CLASS_NAMES.RESEARCH_SIDEBAR_FILTERS}`
    );
    this.hideFilters = this.element.querySelector(
      `.${CLASS_NAMES.RESEARCH_SELECT_FILTERS}.${CLASS_NAMES.HIDE}`
    );
    this.applyFilters = this.element.querySelector(
      `.${CLASS_NAMES.RESEARCH_APPLY_FILTERS}`
    );
    return this;
  }

  /**
   * Create event handlers to enable interaction with view
   * @returns {object} Search A reference to the current instance of the class
   * @chainable
   */
  enable() {
    const attachListener = () => {
      // Only attach if screen < 768
      if (window.innerWidth < 768) {
        this.selectFilters.addEventListener(
          EVENTS.CLICK,
          this.currentSelectFiltersEvent
        );
        this.hideFilters.addEventListener(
          EVENTS.CLICK,
          this.currenthideFiltersEvent
        );
        this.applyFilters.addEventListener(
          EVENTS.CLICK,
          this.currentapplyFilters
        );
      } else {
        this.selectFilters.removeEventListener(
          EVENTS.CLICK,
          this.currentSelectFiltersEvent
        );
        this.hideFilters.removeEventListener(
          EVENTS.CLICK,
          this.currenthideFiltersEvent
        );
        this.applyFilters.removeEventListener(
          EVENTS.CLICK,
          this.currentapplyFilters
        );
      }
    };

    attachListener(); // initial attach
    window.addEventListener(EVENTS.RESIZE, attachListener);

    return this;
  }

  /**
   * Bind event handlers with the proper context of `this`.
   * @returns {object} A reference to the current instance of the class
   * @chainable
   */
  setupHandlers() {
    this.currentSelectFiltersEvent = this.selectFiltersEvent.bind(this);
    this.currenthideFiltersEvent = this.hideFiltersEvent.bind(this);
    this.currentapplyFilters = this.hideFiltersEvent.bind(this);

    return this;
  }

  /**
   * This is events trigger to show filters popup.
   * @returns {object} A reference to the current instance of the class
   */
  selectFiltersEvent() {
    this.filtersWrapper.classList.add(CLASS_NAMES.OPEN);

    return this;
  }

  /**
   * This is events trigger to hide filters popup.
   * @returns {object} A reference to the current instance of the class
   */
  hideFiltersEvent() {
    this.filtersWrapper.classList.remove(CLASS_NAMES.OPEN);

    return this;
  }
}
